<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">门店列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <!-- <el-form :inline="true" :model="formInline" class="user-search">
            
            <el-form-item label="用户手机号">
                <el-input size="small" v-model="formInline.userPhone" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
            </el-form-item>
        </el-form> -->
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="name" label="门店名称" ></el-table-column>
            <el-table-column  prop="phone" label="手机号" ></el-table-column>
            <el-table-column  prop="id" label="门店id" ></el-table-column>
            <el-table-column  prop="buser_id" label="商户id" ></el-table-column>
            <!-- <el-table-column  prop="payChannelName" label="支付通道" ></el-table-column> -->
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" @click="copyClick(scope.row)">大屏链接</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="推广员名称">
                <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号" >
                <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入部门代码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="链接" :visible.sync="urlFlag" width="30%">
            <div>
                {{url}}
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="urlFlag = false">关闭</el-button>
                <el-button size="small" type="primary" @click="copySubmit()">复制</el-button>
            </div>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="总经销商详情" :visible.sync="bindingFlag" width="40%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
                    <el-form-item label="主屏id">
                        <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="machineData" @selection-change="handleSelectionChange" max-height="400" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  type="selection" width="55"></el-table-column>
                    <el-table-column  prop="主屏id" label="主屏id" ></el-table-column>
                    <el-table-column  prop="机器状态" label="机器状态" ></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">添加</el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import {branchList } from '../../../api/userMG'
import { exportFun } from '../../../utils/export'
export default {
    data(){
        return{
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                status:'',
                time:[],
                payOrderId:'',
                userPhone:''
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            channelsList:[],
            divisionOrder:{},
            amountsum:'',
            url:'',
            urlFlag:false,
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        // this.loadPayChannelList()
    },
    methods:{
        copySubmit(){
            const textarea = document.createElement('textarea');
            textarea.value = this.url;
            // 将其设置为不可见，并添加到body中
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            // 移除创建的textarea元素
            document.body.removeChild(textarea);
            this.$message.success('复制成功')
        },
        copyClick(row){
            this.url = `https://mjdcdntest.17yp.com/mini/TakeABathTP/index.html?id=${row.buser_id}`
            this.urlFlag = true
        },
        getdata(){
            branchList().then(res=>{
                this.listData = res.data
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/storeManagement/storeList.vue